import CCForm from './CCForm'
export default CCForm



// WEBPACK FOOTER //
// ./src/components/premium/CCForm/index.js